import React from 'react'
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { MediumButton } from '../styles/Buttons';

const ButtonWrapper = styled.div`
    display: flex; 

    & > button:first-of-type {
        margin: 0 1rem 0 0; 
    }
`;


const FormActionBtns = ({theme, handleEditCancel}) => {
    const { t } = useTranslation();

    return (
        <ButtonWrapper>
            <MediumButton
                type='submit'
                $theme={theme}
            >
                {t('common.saveBtnLabel')}
            </MediumButton>
            <MediumButton
                type='button'
                $theme={theme}
                onClick={handleEditCancel}
            >
                {t('common.cancelBtnLabel')}
            </MediumButton>
        </ButtonWrapper>
    )
}

export default FormActionBtns
